module.exports = __webpack_public_path__ + "static/media/isem.ca565f48.png";